import React, { useEffect, useMemo, useState } from 'react'
import Facade from '@whitecobalt/tungsten/esm/components/Facade';
import FileKeyLoader from '@whitecobalt/tungsten/esm/components/FileKeyLoader';
import Icon from '@whitecobalt/tungsten/esm/components/Icon';
import { useLazyQuery } from '@apollo/client';
import { useHistory, useParams } from 'react-router-dom';
import { useScreenTitle } from '@whitecobalt/tungsten/hooks/useScreenTitle'
import { useEffectMounted } from '@whitecobalt/tungsten/hooks/useEffectMounted'
import { ProductLinePropType, ProductLinesSearchQuery, SearchProductsQuery, SearchProductsQueryType } from '@services/query/EcommerceQueries';
import ProductListContainer from '../Prefabs/ProductListContainer';
import ProductFilter, { StateProps } from '../Prefabs/ProductFilter';
import ProductThumbnail from '../Prefabs/ProductThumbnail';
import { emptyArray } from '@whitecobalt/tungsten/esm/common/utils/assets';

interface SearchListProps {
    
}

const SearchList: React.FunctionComponent<SearchListProps> = () => {
    const { searchText } = useParams<{ searchText: string }>()

    const title = searchText

    useScreenTitle(`Halspan Store - ${title}`);
	
    const history = useHistory()
    
	const [loadProducts, requestSearchProducts] = useLazyQuery<SearchProductsQueryType>(SearchProductsQuery, {
		fetchPolicy: 'no-cache'
	})

	useEffect(() => {
		loadProducts({
			variables: {
                maxResults: 100,
                searchText,
            }
		})
	}, [searchText])

	const ProductLines = requestSearchProducts.data?.SearchProducts.ProductLines || emptyArray
    const Products = requestSearchProducts.data?.SearchProducts.Products || emptyArray

	const fileKeys = useMemo(() => {
		const plFileKeys = ProductLines.filter((each) => !!each.ProductLineImages[0]?.ImageUrl).map((each) => {
			return each.ProductLineImages[0]?.ImageUrl
        })

        const pFileKeys = Products.filter((each) => !!each.ProductImages[0]?.ImageUrl).map((each) => {
			return each.ProductImages[0]?.ImageUrl
        })

        return [...plFileKeys, ...pFileKeys]
	}, [ProductLines, Products])

	const multiFetchPayload = useMemo(() => ({
		"maxWidthInPX": 175,
		"maxHeightInPX": 175,
	}), [])
    
    if(requestSearchProducts.loading) {
        return (
            <>
                <h2 className="mb-5">Search Product "{searchText}"</h2>
                <div className="row">
                    {new Array(8).fill(0).map((_: any, index) => (
                        <div key={index} className="col-md-3 wc-product-search-item">
                            <div className="product-thumbnail">
                                <h4><Facade title rows={0} padding={false} rowListStyle={{margin: 0}} /></h4>
                                <Facade rows={1} padding={false} rowListStyle={{margin: 0}} rowStyle={{ borderRadius: 0, width: '100%', height: 150}} />
                            </div>
                        </div>
                    ))}
                </div>
            </>
        )
    }

    return (
        <FileKeyLoader.MultiFetch
            fileKeys={fileKeys}
            payload={multiFetchPayload}
            cache
            cacheUniqueString="175px"
        >
            <h2 className="mb-5">Search Product "{searchText}"</h2>
            {ProductLines.length > 0 && (
                <>
                    <h4 className="mb-4">Product Lines</h4>
                    <div className="row">
                        {ProductLines.length > 0 ? ProductLines.map((item) => {
                            return (
                                <div key={item.ID} className="col-sm-6 col-lg-4 col-xl-3">
                                    <ProductThumbnail 
                                        productName={item.Name} 
                                        fileKey={item.ProductLineImages[0]?.ImageUrl}
                                        url={`/store/door-core/view/${item.ID}`}/>
                                </div>
                            )
                        }) : (
                            <div className="d-flex justify-content-center w-100">
                                <div className="text-center my-5">
                                    <Icon name="inbox" size={25}/>
                                    <h4 className="mt-2">No Door Blanks & Cores with a name "{searchText}"</h4>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}
            {(Products.length > 0 || (ProductLines.length === 0)) && (
                <>
                    <h4 className="mb-4">Products</h4>
                    <div className="row">
                        {Products.length > 0 ? Products.map((item) => {
                            return (
                                <div key={item.ID} className="col-sm-6 col-lg-3">
                                    <ProductThumbnail 
                                        productName={item.DisplayName} 
                                        fileKey={item.ProductImages[0]?.ImageUrl}
                                        url={`/store/product/view/${item.ID}`}/>
                                </div>
                            )
                        }) : (
                            <div className="d-flex justify-content-center w-100">
                                <div className="text-center my-5">
                                    <Icon name="inbox" size={25}/>
                                    <h4 className="mt-2">No Product with a name "{searchText}"</h4>
                                </div>
                            </div>
                        )}
                        
                    </div>
                </>
            )}
        </FileKeyLoader.MultiFetch>
    )
}

export default SearchList